// 天地图 JavaScript API 4.0 配置
// 文档：<script src="http://api.tianditu.gov.cn/api?v=4.0&tk=您的密钥"></script>
// https://lbs.tianditu.gov.cn/api/js4.0/guide.html
export const TIANDITU_TK = '93e528dc1a75b6942d585baed6439321'





// WEBPACK FOOTER //
// ./src/config/tianditu.js